import './App.css';
import { PrimeReactProvider } from 'primereact/api';
import { Menu } from 'primereact/menu';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import LeftPanel from './components/common/LeftPanel';
import 'primeicons/primeicons.css';
import TopPanel from './components/common/TopPanel';
import React, { useEffect } from "react";
import Routers from './router';

import { useDispatch, useSelector } from 'react-redux'
import {
  BrowserRouter as Router,
  Outlet,
  useNavigate,
  useLocation
} from "react-router-dom";

import { checkToken } from './store/slices/authSlice';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { getMenuByRole } from './metadata/getMenuByRole';
import { useTranslation } from 'react-i18next';

function AppContent() {
  const { auth } = useSelector(state => state.auth);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(checkToken());
  }, []);

  const role = auth?.role ?? 'Админ';
  const items = getMenuByRole(role, t);

  // Добавляем подсветку активного элемента
  const itemsWithActive = items.map(item => ({
    ...item,
    className: location.pathname === item.url ? "active-menu-item" : "",
    command: item.command || (() => { if (item.url) navigate(item.url) }),
  }));

  return (
    <>
      <ConfirmDialog />
      <div className="app">
        {!!auth?.role &&
          <LeftPanel>
            <Menu model={itemsWithActive} className="custom-menu" />
          </LeftPanel>
        }
        <main className='main'>
          <ConfirmPopup />
          <div className="top-panel">
            <TopPanel />
          </div>
          <div className="content">
            <Routers auth={!!auth} />
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
}

function App() {
  return (
    <PrimeReactProvider>
      <Router>
        <AppContent />
      </Router>
    </PrimeReactProvider>
  );
}

export default App;
